module.exports = __webpack_public_path__ + "static/media/ic-magnifying.ab0656d6.svg";